/**
 * @generated SignedSource<<9c75f1186bcccf0ce486b939f6f38a68>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SingatureType = "CONTRACT" | "EOA" | "%future added value";
export type CreateNewDelegateStatementData = {
  email?: ValueWithSignature | null;
  statement: ValueWithSignature;
};
export type ValueWithSignature = {
  signature: string;
  signatureType: SingatureType;
  signerAddress: string;
  value: string;
};
export type DelegateStatementFormMutation$variables = {
  input: CreateNewDelegateStatementData;
};
export type DelegateStatementFormMutation$data = {
  readonly createNewDelegateStatement: {
    readonly statement: {
      readonly discord: string;
      readonly leastValuableProposals: ReadonlyArray<{
        readonly number: string;
      }>;
      readonly mostValuableProposals: ReadonlyArray<{
        readonly number: string;
      }>;
      readonly openToSponsoringProposals: boolean | null;
      readonly statement: string;
      readonly topIssues: ReadonlyArray<{
        readonly type: string;
        readonly value: string;
      }>;
      readonly twitter: string;
    } | null;
  };
};
export type DelegateStatementFormMutation = {
  response: DelegateStatementFormMutation$data;
  variables: DelegateStatementFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "data",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statement",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "discord",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "twitter",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "TopIssue",
  "kind": "LinkedField",
  "name": "topIssues",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "openToSponsoringProposals",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = [
  (v3/*: any*/),
  (v9/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DelegateStatementFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Delegate",
        "kind": "LinkedField",
        "name": "createNewDelegateStatement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DelegateStatement",
            "kind": "LinkedField",
            "name": "statement",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "OnChainProposal",
                "kind": "LinkedField",
                "name": "mostValuableProposals",
                "plural": true,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OnChainProposal",
                "kind": "LinkedField",
                "name": "leastValuableProposals",
                "plural": true,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DelegateStatementFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Delegate",
        "kind": "LinkedField",
        "name": "createNewDelegateStatement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DelegateStatement",
            "kind": "LinkedField",
            "name": "statement",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "OnChainProposal",
                "kind": "LinkedField",
                "name": "mostValuableProposals",
                "plural": true,
                "selections": (v10/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OnChainProposal",
                "kind": "LinkedField",
                "name": "leastValuableProposals",
                "plural": true,
                "selections": (v10/*: any*/),
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "77ea7a91763f656404bdcc1cbc095d0d",
    "id": null,
    "metadata": {},
    "name": "DelegateStatementFormMutation",
    "operationKind": "mutation",
    "text": "mutation DelegateStatementFormMutation(\n  $input: CreateNewDelegateStatementData!\n) {\n  createNewDelegateStatement(data: $input) {\n    statement {\n      statement\n      mostValuableProposals {\n        number\n        id\n      }\n      leastValuableProposals {\n        number\n        id\n      }\n      discord\n      twitter\n      topIssues {\n        type\n        value\n      }\n      openToSponsoringProposals\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "18cd9b75cb7c1e6cb8c661ba5522e1d5";

export default node;
